/* eslint-disable no-console */
window.addEventListener("load", () => {
  const baseName = "wp-block-gvv-results";
  const blocks = document.querySelectorAll(`.${baseName}`);

  const findPostId = () => {
    const postIdClass = Array.from(document.body.classList).find((className) =>
      className.startsWith("postid-"),
    );
    if (!postIdClass) {
      return null;
    }

    const parsed = parseInt(postIdClass.replace("postid-", ""), 10);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const escapeHtml = (value) => {
    const stringValue = String(value || "");
    return stringValue
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  const formatDate = (date) => {
    if (!date) {
      return "-";
    }

    const parsed = new Date(`${date}T00:00:00`);
    if (Number.isNaN(parsed.getTime())) {
      return escapeHtml(date);
    }

    return parsed.toLocaleDateString("nl-NL");
  };

  const createResultItem = (result) => {
    const homeName = escapeHtml(result.hometeam_name);
    const awayName = escapeHtml(result.awayteam_name);
    const score = escapeHtml((result.score || "-").replaceAll(" ", ""));
    const date = escapeHtml(formatDate(result.start_date));
    const homeLogo = result.hometeam_logo
      ? ` style="background-image:url('${escapeHtml(result.hometeam_logo)}')"`
      : "";
    const awayLogo = result.awayteam_logo
      ? ` style="background-image:url('${escapeHtml(result.awayteam_logo)}')"`
      : "";

    return `<div class="${baseName}__content-item">
      <div class="${baseName}__content-item__team ${baseName}__content-item__team--home">
        <div class="${baseName}__content-item__team__logo"${homeLogo}></div>
        <span>${homeName}</span>
      </div>
      <div class="${baseName}__content-item__team ${baseName}__content-item__team--away">
        <span>${awayName}</span>
        <div class="${baseName}__content-item__team__logo"${awayLogo}></div>
      </div>
      <div class="${baseName}__content-item__score">${score}</div>
      <div class="${baseName}__content-item__date">${date}</div>
    </div>`;
  };

  const isTeamDetailPage = document.body.classList.contains("single-team");

  blocks.forEach((block) => {
    const perPage = parseInt(block.dataset.resultsPerPage || "5", 10);
    const postsPerPage = Number.isNaN(perPage) ? 5 : perPage;

    const searchWrap = block.querySelector(`.${baseName}__search`);
    const searchInput = searchWrap
      ? searchWrap.querySelector('input[type="search"]')
      : null;
    const content = block.querySelector(`.${baseName}__content`);
    const paginationWrap = block.querySelector(
      `.${baseName}__toprow__pagination`,
    );
    const prevButton = block.querySelector(
      `.${baseName}__toprow__pagination__button.is-prev`,
    );
    const nextButton = block.querySelector(
      `.${baseName}__toprow__pagination__button:not(.is-prev)`,
    );

    if (isTeamDetailPage && searchWrap) {
      searchWrap.classList.add("is-hidden");
    }

    if (!content) {
      return;
    }

    let searchTerm = "";
    let pagination = {
      current_page: 1,
      total_pages: 1,
      total_results: 0,
    };

    const postId = isTeamDetailPage ? findPostId() : null;

    const applyPaginationState = () => {
      if (!paginationWrap) {
        return;
      }

      if (pagination.total_pages <= 1) {
        paginationWrap.classList.add("inactive");
      } else {
        paginationWrap.classList.remove("inactive");
      }

      if (prevButton) {
        prevButton.classList.toggle("inactive", pagination.current_page <= 1);
      }

      if (nextButton) {
        nextButton.classList.toggle(
          "inactive",
          pagination.current_page >= pagination.total_pages,
        );
      }
    };

    const renderResults = (results) => {
      if (!results.length) {
        content.innerHTML = `<div class="${baseName}__content-empty">Er zijn geen uitslagen gevonden</div>`;
        return;
      }

      content.innerHTML = results.map(createResultItem).join("");
    };

    const fetchResults = async (page) => {
      const params = new URLSearchParams({
        action: "get_results_paginated",
        posts_per_page: String(postsPerPage),
        page: String(page),
      });

      if (gvvAjax.nonce) {
        params.append("nonce", gvvAjax.nonce);
      }

      if (!isTeamDetailPage && searchTerm) {
        params.append("search", searchTerm);
      }

      if (isTeamDetailPage && postId) {
        params.append("team_post_id", String(postId));
      }

      const response = await fetch(`${gvvAjax.ajax_url}?${params.toString()}`);
      if (response.status !== 200) {
        console.error("Error fetching results:", response.statusText);
        return null;
      }

      return response.json();
    };

    const loadPage = async (page) => {
      const response = await fetchResults(page);
      if (!response || !response.success || !response.data) {
        renderResults([]);
        pagination = {
          current_page: 1,
          total_pages: 1,
          total_results: 0,
        };
        applyPaginationState();
        return;
      }

      renderResults(response.data.results || []);
      pagination = response.data.pagination || pagination;
      applyPaginationState();
    };

    loadPage(1);

    if (searchInput && !isTeamDetailPage) {
      let timer = null;
      searchInput.addEventListener("input", (event) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          searchTerm = event.target.value.trim();
          loadPage(1);
        }, 250);
      });
    }

    if (prevButton) {
      prevButton.addEventListener("click", (event) => {
        event.preventDefault();
        if (pagination.current_page <= 1) {
          return;
        }
        loadPage(pagination.current_page - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", (event) => {
        event.preventDefault();
        if (pagination.current_page >= pagination.total_pages) {
          return;
        }
        loadPage(pagination.current_page + 1);
      });
    }
  });
});
/* eslint-enable no-console */
